// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2Q1cK","title":"Images90_title__1coMj","images":"Images90_images__1w4qE"};